<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>账户管理</BreadcrumbItem>
      <BreadcrumbItem>机构管理</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          机构列表
        </p>

        <Tree :data="data5" :render="renderContent" class="demo-tree-render"></Tree>
      </Card>
    </div>
    <Modal
        v-model="showModal"
        :title="organization.id ? '编辑机构' : '添加机构'"
        :mask-closable="false"
        :loading="modalLoading"
        @on-ok="handleOK()"
        :styles="{top: '10px'}"
        width="500"
    >
      <Form ref="formValidate" label-position="left" :label-width="100" :model="organization" :rules="organizationRules" style="padding: 15px">
        <FormItem label="机构名称" prop="name">
          <Input v-model.trim="organization.orgName" ></Input>
        </FormItem>
        <FormItem label="上级机构" prop="orgId">
          <Poptip v-model="treePopVisible" class="demo-tree-pop" placement="bottom-start">
            <Input v-model="selectParentOrgName" placeholder="请选择"></Input>
            <div slot="content">
              <Tree class="org-tree-select" style="width: 100%;" :data="data6" @on-select-change="handleCheckChange"></Tree>
            </div>
          </Poptip>

        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'OrganizationList',
  data () {
    return {
      showModal: false,
      modalLoading: true,
      organization: {},
      treePopVisible: false,
      selectParentOrgName: null,
      keyword: '',
      organizationRules: {
        orgName: [
          {required: true, message: '请输入机构名称'}
        ]
      },
      data5: [
        {
          title: '全部机构',
          expand: true,
          render: (h, { root, node, data }) => {
            return h('span', {
              style: {
                display: 'inline-block',
                width: '100%'
              }
            }, [
              h('span', [
                h('Icon', {
                  props: {
                    type: 'ios-folder-outline'
                  },
                  style: {
                    marginRight: '8px'
                  }
                }),
                h('span', data.title)
              ]),
              h('span', {
                style: {
                  display: 'inline-block',
                  float: 'right',
                  marginRight: '32px'
                }
              }, [
                h('Button', {
                  props: Object.assign({}, this.buttonProps, {
                    icon: 'ios-add',
                    type: 'primary'
                  }),
                  style: {
                    width: '64px'
                  },
                  on: {
                    click: () => { this.appendOrg(data) }
                  }
                })
              ])
            ])
          },
          children: []
        }
      ],
      data6: [
        {
          title: '全部机构',
          expand: true,
          children: []
        }
      ],
      buttonProps: {
        type: 'default',
        size: 'small'
      }
    }
  },
  computed: {
    ...mapState({
      loginUser: 'user'
    })
  },
  methods: {
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    renderContent (h, { root, node, data }) {
      return h('span', {
        class: 'ivu-tree-title',
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          h('Icon', {
            props: {
              type: data.source === 1 ? 'ios-lock-outline' : 'ios-paper-outline'
            },
            style: {
              marginRight: '8px'
            }
          }),
          h('span', data.title)
        ]),
        h('span', {
          style: {
            display: 'inline-block',
            float: 'right',
            marginRight: '32px'
          }
        }, [
          h('Button', {
            props: Object.assign({}, this.buttonProps, {
              icon: 'ios-add',
              type: 'primary',
              ghost: true
            }),
            style: {
              marginRight: '8px'
            },
            on: {
              click: () => { this.appendOrg(data) }
            }
          }),
          h('Button', {
            props: Object.assign({}, this.buttonProps, {
              icon: 'ios-create-outline',
              type: 'primary',
              ghost: true
            }),
            style: {
              marginRight: '8px'
            },
            on: {
              click: () => { this.updateOrg(root, node, data) }
            }
          }),
          h('Button', {
            props: Object.assign({}, this.buttonProps, {
              icon: 'ios-trash-outline',
              type: 'error',
              ghost: true
            }),
            style: {
              'display': data.source === 1 ? 'none' : 'inline-block'
            },
            on: {
              click: () => { this.deleteOrg(root, node, data) }
            }
          })
        ])
      ])
    },
    appendOrg (data) {
      let self = this
      const children = {}
      children.expand = true
      if (data.nodeKey === 0) {
        children.parentId = null
      } else {
        children.parentId = data.id
      }
      self.selectParentOrgName = data.title
      this.organization = children
      this.showModal = true
      this.$refs['formValidate'].resetFields()
    },
    updateOrg (root, node, data) {
      if (data.parentId) {
        this.selectParentOrgName = data.parentOrg.title
      } else {
        this.selectParentOrgName = '全部机构'
      }
      this.organization = JSON.parse(JSON.stringify(data))
      this.showModal = true
    },
    deleteOrg (root, node, data) {
      this.$Modal.confirm({
        title: `确认删除机构【${data.title}】？`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          try {
            this.beforeSave()
            let deletedOrg = (await this.$http.delete(`/api/admin/orgs/${data.id}`)).body
            let orgTreeResp = await Vue.http.get('/api/admin/org/treeList')
            this.data5[0].children = orgTreeResp.body
            this.data6[0].children = orgTreeResp.body
            this.afterSave()
          } catch (e) {
            this.afterSave(e)
          }
        }
      })
    },
    // 点击树形获取该行
    handleCheckChange (val) {
      let self = this
      if (val.nodeKey === 0) {
        self.selectParentOrgName = val[0].title
        self.organization.parentId = null
      } else {
        self.selectParentOrgName = val[0].title
        self.organization.parentId = val[0].id
      }
      self.treePopVisible = false
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
    },
    async search () {
      try {
        this.$Loading.start()
        let queryStr = `keyword=${this.keyword ? this.keyword : ''}`
        this.$Loading.finish()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async handleOK () {
      let validPass = false
      this.$refs['formValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      if (!validPass) {
        this.modalLoading = false
        this.$nextTick(() => {
          this.modalLoading = true
        })
        return
      }

      try {
        this.beforeSave()
        if (this.organization.id) {
          let updatedOrg = (await this.$http.put(`/api/admin/orgs/${this.organization.id}`, this.organization)).body
          let orgTreeResp = await Vue.http.get('/api/admin/org/treeList')
          this.data5[0].children = orgTreeResp.body
          this.data6[0].children = orgTreeResp.body
        } else {
          let createdOrg = (await this.$http.post(`/api/admin/orgs`, this.organization)).body
          let orgTreeResp = await Vue.http.get('/api/admin/org/treeList')
          this.data5[0].children = orgTreeResp.body
          this.data6[0].children = orgTreeResp.body
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }

      this.showModal = false
      this.selectParentOrgName = null
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let orgTreeResp = await Vue.http.get('/api/admin/org/treeList')
      next(vm => {
        vm.data5[0].children = orgTreeResp.body
        vm.data6[0].children = orgTreeResp.body
      })
    } catch (e) {
      next(vm => {
        vm.data5.children = []
        vm.data6.children = []
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let orgTreeResp = await Vue.http.get('/api/admin/org/treeList')
      this.data5[0].children = orgTreeResp.body
      this.data6[0].children = orgTreeResp.body
      next()
    } catch (e) {
      this.data5.children = []
      this.data6.children = []
      next()
    }
  }
}
</script>

<style scoped="scope" scss>
.demo-tree-render .ivu-tree-title {
  width: 100%;
}
.demo-tree-pop {
  width: 100%;
}
/deep/ .demo-tree-pop .ivu-poptip-rel {
  width: 100%;
}

.org-tree-select {
  max-height: 500px;
  overflow: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/account/OrganizationList.vue